module.exports = __webpack_public_path__ + "img/drone.27d1acfe.png";